import SockelBrett from "./SockelBrett";
import {v3} from "oc-threejs/short3";

export default class Sockel {
    // DO NOT CHANGE: Hier wird der Classname des Brettes verwendet - für Einheitlichkeit in der JSON
    className = "Brett";

    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    constructor(schrank) {
        this.sockelBretter = {
            links: null,
            rechts: null,
            vorne: null
        };
        this.schrank = schrank;
        this.needsBlende = this.schrank.sockelOption == "mitBlende";
    }

    compile() {
        this.needsBlende = this.schrank.sockelOption == "mitBlende";

        const outer = this.schrank.corpusBox;
        const inner = this.schrank.elementsBox;
        const xBox = this.schrank.options.getBool('aussenwand_durchgehend_unten') && !this.needsBlende ? inner : outer;

        const sockelFront = inner.max.z - this.schrank.options.getFloat( 'sockel_ruecksprung_vorn');
        const boxMinY = outer.min.y - (this.schrank.sockelOption == "mitBlende" ? this.schrank.sockelHoehe : 0.0);

        this.sockelBretter.vorne = this.createFrontBlende(this.needsBlende ? outer : inner, sockelFront, boxMinY);
        
        if(this.needsBlende) {
            this.sockelBretter.links = this.createSeitenBlendeLinks(outer, sockelFront, boxMinY);
            this.sockelBretter.rechts = this.createSeitenBlendeRechts(outer, sockelFront, boxMinY);
        } else {
            this.sockelBretter.links = null;
            this.sockelBretter.rechts = null;
        }

        _.forEach( this.sockelBretter, brett => {
            if (brett) {
                brett.compile();
            }
        });
    }

    createFrontBlende(schrankbox, ruecksprung, minY) {
        const frontBlende = new SockelBrett(this.schrank);
        frontBlende.box = new THREE.Box3(
            v3(schrankbox.min.x, minY, ruecksprung - this.schrank.options.getFloat('brett_staerke')),
            v3(schrankbox.max.x, minY + this.schrank.sockelHoehe, ruecksprung)
        );
        frontBlende.boxToVertices();
        if(frontBlende.object3d && _.isEmpty(this.object3d?.geometry?.attributes)) {
            frontBlende.object3d.updateGeometry();
        }

        return frontBlende;
    }

    createSeitenBlendeLinks(schrankBox, ruecksprung, minY) {
        const brettstärke = this.schrank.options.getFloat('brett_staerke');
        const blende = new SockelBrett(this.schrank, 'xz');
        blende.box = new THREE.Box3(
            v3(schrankBox.min.x, minY, schrankBox.min.z),
            v3(schrankBox.min.x + brettstärke, minY + this.schrank.sockelHoehe, ruecksprung - brettstärke)
        );
        blende.boxToVertices();
        if(blende.object3d && _.isEmpty(this.object3d?.geometry?.attributes)) {
            blende.object3d.updateGeometry();
        }

        return blende;
    }

    createSeitenBlendeRechts(schrankBox, ruecksprung, minY) {
        const brettstärke = this.schrank.options.getFloat('brett_staerke');
        const blende = new SockelBrett(this.schrank, 'xz');
        blende.box = new THREE.Box3(
            v3(schrankBox.max.x - brettstärke, minY, schrankBox.min.z),
            v3(schrankBox.max.x, minY + this.schrank.sockelHoehe, ruecksprung - brettstärke)
        );
        blende.boxToVertices();
        if(blende.object3d && _.isEmpty(this.object3d?.geometry?.attributes)) {
            blende.object3d.updateGeometry();
        }

        return blende;
    }

    getMaterialProduct() {
        if (!Commons.isEmpty(APP.arrangement.materials.sockel)) {
            return APP.findProduct(this.materialArtikelnummer);
        } else {
            return null;
        }
    }

    get materialArtikelnummer() {
        return APP.arrangement.materials.sockel;
    }

    toJSON() {
        const json = {
            sockelBretter: {
                links: this.sockelBretter.links?.toJSON(),
                rechts: this.sockelBretter.rechts?.toJSON(),
                vorne: this.sockelBretter.vorne?.toJSON(),
            }
        }
        return json;
    }

    // not needed sockel gets reconstructed on load
    fromJSON(json) {
    }
}